import { SxProps, Theme } from '@mui/material'

type Styles = Record<string, SxProps<Theme>>

export const stepperStyles: Styles = {
  root: {
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: 'background.paper',
    position: 'relative'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: 2
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 0
  },
  contentContainer: {
    textAlign: 'center',
    padding: '3px'
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3
  },
  labelText: {
    mb: 1,
    textAlign: 'center'
  },
  buttonContainer: {
    display: 'flex',
    gap: 2
  },
  listButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '100%'
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 2,
    backgroundColor: 'background.paper',
    borderTop: '1px solid',
    borderTopColor: 'divider'
  },
  expandButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    width: '100%'
  },
  listContainer: {
    mt: 2,
    maxHeight: '200px',
    overflowY: 'auto'
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    px: 2,
    backgroundColor: '#f5f5f5',
    p: 1,
    borderRadius: 1,
    mb: 1
  },
  greenText: {
    color: '#5C8E2F'
  },
  skuList: {
    mt: 2,
    p: 2,
    backgroundColor: '#f5f5f5',
    borderRadius: 1,
    boxShadow: 1
  }
}
